<template>
  <div class="operator-main" @click="handleClick">
    <i class="el-icon-plus"></i>
  </div>
</template>
<script>
export default {
  name: "index",
  methods: {
    handleClick() {
      this.$emit("click")
    }
  }
}
</script>
<style scoped lang="scss">
.operator-main {
  position: fixed;
  bottom: 1rem;
  right: 0.4rem;
  z-index: 99;
  width: 1.4594594594594594rem;
  height: 1.4594594594594594rem;
  background: linear-gradient(144deg, #2343C6 0%, #5042EE 100%);
  box-shadow: 0 0.10810810810810811rem 0.2702702702702703rem 0 rgba(0, 0, 0, 0.4);
  border-radius: 20rem;
  text-align: center;
  display: flex;
  justify-content: center;

  .el-icon-plus {
    align-self: center;
    color: #fff;
    font-size: 0.6rem;
    font-weight: bold;
  }
}
</style>